import { Component, OnInit } from '@angular/core';
import { SecurityService } from 'src/app/api/security.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { HCaptchaService } from 'src/app/services/hcaptcha.service';

@Component({
    selector: 'auth-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  loading = false;
  loadingCaptcha = false;
  error: string = null;
  success = false;

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  constructor(
    private fb: UntypedFormBuilder,
    private securityService: SecurityService,
    private hCaptchaService: HCaptchaService
  ) { }

  ngOnInit() {
  }

  async onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.error = null;
      this.success = false;
      let captcha: string = "";

      if (this.hCaptchaService.isCaptchaEnabled) {
        this.loadingCaptcha = true;

        try {
          captcha = await this.hCaptchaService.getCaptcha();
        } catch (err) {
          console.log("hcaptcha_ERROR", err);
        }finally {
          this.loadingCaptcha = false;
        }
      }

      this.securityService.requestPasswordReset(this.email.value, captcha).subscribe(response => {
        this.loading = false;
        this.success = response;
        this.form.reset();
      }, err => {
        this.loading = false;
        this.error = err?.errors?.[0]?.message || err?.error?.error_description;
      });
    } else {
      this.error = 'invalid email';
    }
  }

  get email() { return this.form.get('email'); }
}
